import { CSSProperties } from 'react';

export const antLayoutSider: CSSProperties = {
  position: 'relative',
};
export const antLayoutSiderMobile: CSSProperties = {
  position: 'fixed',
  top: 0,
  bottom: 0,
  left: 0,
  height: 'auto',
  zIndex: 999,
  backgroundColor: '#fff',
  boxShadow: '2px 0 10px rgba(9, 37, 69, 0.12)',
};
